import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import EventFinished from "src/components/EventFinished";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";

const DragonDiceNights = () => {
  const { t, i18n } = useTranslation();

  return (
    <DragonDiceNightsDiv>
      <EventFinished
        scheduleKeyName="dragonDiceNights"
        eventType="promotion"
      />
      <Hero
        bgImage="promotions/dining/dragon-dice-nights/DDN-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={
          `promotions/dining/dragon-dice-nights/DDN-2400x2400px-${i18n.language}.png`
        }
        darkenBg={0.5}
        arrowBounce={true}
        showArrow={true}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("dragonDiceNights.content.subtitle")}
            text={t("dragonDiceNights.content.text")}
            borderColor="#ffe69b"
            className="pb-3"
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown>{t("dragonDiceNights.content.howItWorksTitle")}</ReactMarkdown>
              <div className="ps-4 pt-4">
                <ReactMarkdown>{t("dragonDiceNights.content.howItWorks1")}</ReactMarkdown>
                <ReactMarkdown>{t("dragonDiceNights.content.howItWorks2")}</ReactMarkdown>
                <ReactMarkdown>{t("dragonDiceNights.content.howItWorks3")}</ReactMarkdown>
                <ReactMarkdown>{t("dragonDiceNights.content.howItWorks4")}</ReactMarkdown>
              </div>
              <ReactMarkdown>{t("dragonDiceNights.content.details")}</ReactMarkdown>
              <p className="mt-5"><small>
                {t("dragonDiceNights.content.small")}
              </small></p>
            </Col>
          </Row>
        </container-div>
        <container-div>
          <ResponsiveImage
            src={`promotions/dining/dragon-dice-nights/DDN-collage-2400x800px.jpg`}
            alt={t("allYouCanEat2025.title")}
            className="mt-5"
            />
        </container-div>
      </MainContentDiv>
    </DragonDiceNightsDiv>
  );
};

const DragonDiceNightsDiv = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #ffe69b;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #ffe69b;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: left;
  ul {
    list-style: none;
    padding-bottom: 0.8rem;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
      &:before {
        content: "•";
        color: #ffe69b;
        font-weight: bold;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
`;

export default DragonDiceNights;